import { Currency } from '@/graphql/generated/types.generated';
import { currencySymbol } from './currency-symbol';

/**
 * The ANDIE "extra credits" top-up offer surfaced when a user hits their usage limit.
 *
 * There is no backend product for this yet, so the price is resolved on the frontend
 * from the workspace currency. Amounts are not a simple symbol swap (BRL is priced
 * differently), so we detect the currency by its symbol template:
 *   - `R$…` → BRL → R$29.99
 *   - `€…` / `$…` → EUR / USD → 5 (rendered with the user's own symbol)
 *   - anything else → fallback to €5
 *
 * The `%default%` placeholder in `Currency.symbol` is filled by `currencySymbol()`.
 */
const TOPUP_CREDITS = 500;
const EUR_FALLBACK_SYMBOL = '%default% €';

export const andieTopupOffer = (currency?: Pick<Currency, 'symbol'> | null) => {
    const symbol = currency?.symbol ?? '';

    // Test `R$` before `$`, since the BRL symbol also contains `$`.
    if (symbol.includes('R$')) {
        return { credits: TOPUP_CREDITS, price: currencySymbol(29.99, currency) };
    }

    if (symbol.includes('€') || symbol.includes('$')) {
        return { credits: TOPUP_CREDITS, price: currencySymbol(5, currency) };
    }

    return { credits: TOPUP_CREDITS, price: currencySymbol(5, { symbol: EUR_FALLBACK_SYMBOL }) };
};
